import { apiRequest } from "@portal/lib/ky/utils";
import { PaymentListFilters } from "@portal/store/Filters/credits/type";
import { PaymentDetails, PaymentList } from "@portal/types/entities/payment";
import { PageList } from "@portal/types/page-list";
import { RequestConfig } from "../types/common";

export async function getPaymentList(
  params: RequestConfig<PaymentListFilters>
) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<PaymentListFilters>["filters"],
    PageList<PaymentList, unknown>
  >({
    method: "POST",
    url: "v1/payments/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function getPaymentDetails(params?: string) {
  const data = await apiRequest<unknown, PaymentDetails>({
    method: "GET",
    url: `v1/payments/${params?.toString()}`,
  });
  return await data.json();
}
export async function getPaymentMode() {
  const data = await apiRequest<unknown, PageList<string, unknown>>({
    method: "GET",
    url: `v1/payment-modes`,
  });
  return await data.json();
}